export const TEMPLATE_PACKAGE_COMMUNITY = '@react-native-community/template';
export const TEMPLATE_PACKAGE_LEGACY = 'react-native';
export const TEMPLATE_PACKAGE_LEGACY_TYPESCRIPT =
  'react-native-template-typescript';

// This version moved from inlining the template to using @react-native-community/template
export const TEMPLATE_COMMUNITY_REACT_NATIVE_VERSION = '0.75.0';
